import { FormRow } from '@creditornot/cb-form';
import { Input } from '@creditornot/cb-input';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { RFFFieldErrorWrapper } from 'common/components';
import { Typography as T } from 'common/typography';

const IntroText = styled(T.Body1)`
  display: block;
  margin-block-end: 16px;
`;

const General = () => {
  const intl = useIntl();
  return (
    <>
      <IntroText>
        <FormattedMessage id="venue-data-collection.venue-information-form.intro" />
      </IntroText>
      <FormRow
        label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.name' })}
        labelHtmlFor="draft-venue-form-name"
        required
      >
        <Field<string | undefined> name="name">
          {field => (
            <RFFFieldErrorWrapper field={field} showErrorImmediately>
              {input => <Input id="draft-venue-form-name" {...input} />}
            </RFFFieldErrorWrapper>
          )}
        </Field>
      </FormRow>
      <FormRow
        label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.address' })}
        labelHtmlFor="draft-venue-form-address"
        required
      >
        <Field<string | undefined> name="address">
          {field => (
            <RFFFieldErrorWrapper field={field} showErrorImmediately>
              {input => <Input id="draft-venue-form-address" {...input} />}
            </RFFFieldErrorWrapper>
          )}
        </Field>
      </FormRow>
      <FormRow
        label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.website' })}
        labelHtmlFor="draft-venue-form-website"
      >
        <Field<string | undefined> name="website">
          {field => (
            <RFFFieldErrorWrapper field={field} showErrorImmediately>
              {input => <Input id="draft-venue-form-website" {...input} />}
            </RFFFieldErrorWrapper>
          )}
        </Field>
      </FormRow>
    </>
  );
};

export default General;
